const languages = {
  arabic: 'ar-SA',
  dutch: 'nl-NL',
  english: 'en-GB',
  german: 'de-DE',
  polish: 'pl-PL',
  turkish: 'tr-TR',
} as const;

// create a type thats the value of the languages object
type LanguageValue = (typeof languages)[keyof typeof languages];

export const getLocale = (language: string | undefined): LanguageValue | undefined => {
  if (!language) return;
  const languageKnown = isLanguageValue(language);

  if (!languageKnown) {
    console.warn(`Language ${language} not found`);

    return;
  }

  return language;
};

function isLanguageValue(language: string | undefined): language is LanguageValue {
  return Object.values(languages).includes(language as LanguageValue);
}
